export const handleChangeDataCouriersPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_COURIERS', name, value
});